var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        attrs: { type: "hidden", name: "" + _vm.name },
        domProps: { value: _vm.rating }
      }),
      _vm._v(" "),
      _c(
        "star-rating",
        _vm._b(
          {
            attrs: { rating: _vm.rating, "show-rating": false },
            on: { "rating-selected": _vm.setRating }
          },
          "star-rating",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f3525f8", { render: render, staticRenderFns: staticRenderFns })
  }
}